import { makeStyles } from '@material-ui/core/styles';

import { XMEI_PRIMARY_COLOR, XMEI_SECONDARY_COLOR } from 'src/consts/common';

export const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submit: {
    margin: theme.spacing(2, 0, 2),
    backgroundColor: XMEI_SECONDARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
    '&:hover': {
      backgroundColor: XMEI_PRIMARY_COLOR,
    },
  },
  cardSignatureIntention: {
    marginTop: 10,
    marginBottom: 10,
    marginHorizontal: 10,
    paddingVertical: 5,
    backgroundColor: XMEI_SECONDARY_COLOR,
  },
  signatureText: {
    textAlign: 'justify',
    paddingHorizontal: 8,
    color: '#FFFF',
  },
}));
